// eslint-disable-next-line import/prefer-default-export
export const MIN_SEARCH_RADIUS_M = 6437.376;
